import { DownOutlined } from '@ant-design/icons';
import { Form, Input, InputNumber, Popconfirm, Spin, Table, Typography } from 'antd';
import React, { useState } from 'react';
import "./Table.css"
import editIcon from '../../Assets/img/edit.png';
import { updateDowntime } from '../../API-Interaction/apiServices/logs.api';
import { useDispatch, useSelector } from 'react-redux';
import NoDataFound from '../Helpers/NoDataFound';




const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: false,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};



const CustomTable = (props) => {

    const { current } = useSelector(state => state.plant)
    const dispatch = useDispatch()

    const DownTimeLogOps = [
        ...props.columns,
        {
            title: "Operations",
            dataIndex: "operations",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => save(record)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Save
                        </Typography.Link>
                        <a onClick={cancel}>Cancel</a>
                    </span>
                ) : (
                    <img disabled={editingKey !== ''} onClick={() => edit(record)} src={editIcon} style={{ width: "20px", cursor: "pointer", marginRight: "20px" }} />
                );
            },
        },
    ];

    const [form] = Form.useForm();
    const [data, setData] = useState(props.dataSource);
    const [editingKey, setEditingKey] = useState('');

    const isEditing = (record) => {
        return record.key === editingKey;
    }

    const edit = (record) => {
        form.setFieldsValue({
            reasons: '',
            comment: '',
            ...record,
        });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (record, key) => {
        const { comment, reason } = await form.validateFields();
        await updateDowntime({ comment, reason, record }, dispatch, current)
        setEditingKey('')
    };


    const mergedColumns = DownTimeLogOps.map((col, index) => {
        if (!col.editable)
            return col;    
        return {
            ...col,
            key: index.toString(),
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'text',
                dataIndex: col.dataIndex,
                editing: isEditing(record), //&& ((record.type!='disconnectTimeEnded' && col.dataIndex!='reason') ||(record.type !='disconnectTimeEnded')||(record.type =='disconnectTimeEnded' && col.dataIndex!='reason')),
                title: col.title
            }),
        };
    });

    return (

        // Table With Checkbox
        props.checkbox ?
            <Table
                columns={props.columns}
                dataSource={props.dataSource}
                rowSelection={props.rowSelection}
                className="TableMain"
                locale={{
                    emptyText: <NoDataFound />
                }}
            />

            // Table With Editable Rows
            : props.editable ?
                <Form form={form} component={false}>
                    <Table
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        bordered
                        dataSource={props.dataSource}
                        columns={mergedColumns}
                        rowClassName="editable-row"
                        pagination={{
                            onChange: cancel,
                        }}
                        locale={{
                            emptyText: <NoDataFound />
                        }}
                    />
                </Form>
                :
                // Normal Table
                <Table
                    columns={props.columns}
                    dataSource={props.dataSource}
                    className="TableMain"
                    locale={{
                        emptyText: <NoDataFound />
                    }}
                />
    )
}

export default CustomTable